import { render } from "./FornitureEE.vue?vue&type=template&id=5c451cd5"
import script from "./FornitureEE.vue?vue&type=script&lang=js"
export * from "./FornitureEE.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__